module.exports = __webpack_public_path__ + "static/media/bookmark-full.b764b03f.svg";